import axiosInterceptor from 'services/axiosInterceptor'
import { API_BASE_URL } from 'services/constants'

import type { EmailPreferences, EmailPreferencesUpdate } from '../types/notification.types'

/** The signed-in user's notification email settings (MYD-543). */

const api = () => axiosInterceptor(API_BASE_URL)
const PATH = '/users/me/notification-preferences'

export async function getEmailPreferences(): Promise<EmailPreferences> {
	const { data } = await api().get<EmailPreferences>(PATH)
	return data
}

/** Saves a change and returns the full settings as stored. */
export async function updateEmailPreferences(update: EmailPreferencesUpdate): Promise<EmailPreferences> {
	const { data } = await api().put<EmailPreferences>(PATH, update)
	return data
}
